export default __webpack_public_path__ + "static/media/cp_geo_vn.aa591ead.svg";